var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fbc3a4}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m111.1 53c1.7 4.2-7.4 35.4 3.6 50.1 4 5.5 5.6 15.4-5.4 13.4-12.3-2.3-25.4-31-26.3-23.8-2.5 19.9 22.2 59.3 16.7 60.4-12.1 2.4-49.1-28.6-51.2-47.2-6.7-59.7-8.1-82.2 4-84.6 12.1-2.4 25.3-49.3 58.6 31.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftHand);
export default __webpack_public_path__ + "static/media/left_hand.1a4ae334b864af5025a1c771eb1dd43e.svg";
export { ForwardRef as ReactComponent };